// "Last sync 2 h ago" on connector rows (FIG-345 · UC-231). Relative time of
// the last successful sync, as decided on 20 Oct; the exact time goes in the
// tooltip. When a sync counts as stale (and the dot turns amber or red) is
// owned by the Technical Shaper, so nothing here changes the status dot.
import type { LastSync } from './types/connectionSync';

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatRelativeSince(iso: string, now: Date = new Date()): string {
  const elapsed = now.getTime() - Date.parse(iso);
  if (Number.isNaN(elapsed)) return 'unknown';
  if (elapsed < MINUTE) return 'just now';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min ago`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)} h ago`;
  return `${Math.floor(elapsed / DAY)} d ago`;
}

export interface LastSyncDisplay {
  text: string;
  /** Exact time for the tooltip, or null. */
  title: string | null;
}

/** Row text for a connection's last successful sync; null while it is loading or unknown. */
export function describeLastSync(lastSync: LastSync | null | undefined, now: Date = new Date()): LastSyncDisplay | null {
  if (!lastSync) return null;
  if (!lastSync.at) return { text: 'Last sync: not recorded yet', title: null };
  return {
    text: `Last sync ${formatRelativeSince(lastSync.at, now)}`,
    title: new Date(lastSync.at).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }),
  };
}
